module.exports = __webpack_public_path__ + "static/media/C_K.edd7b29a.png";